import axios from 'axios'
import qs from 'qs'

export async function getDevicesByIds(devicesIds, excludedDevicesIds, filters) {
    const params =
        devicesIds?.length > 0
            ? {
                  ids: devicesIds
              }
            : {
                  ...filters,
                  e_ids: excludedDevicesIds
              }
    return axios
        .get(`${process.env.API_URL}/devices`, {
            params,
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        })
        .then(response => response.data)
}

export async function getDevicesTotalCount(params) {
    return axios
        .get(`${process.env.API_URL}/devices`, {
            params: {
                ...params,
                o_c: 1
            },
            paramsSerializer: params => {
                return qs.stringify({ ...params })
            }
        })
        .then(response => response.data)
}

export async function getLocationsForDevicesMove() {
    return axios
        .get(`${process.env.API_URL}/locations`, {
            params: {
                w_o_d_s: 1
            }
        })
        .then(response => response.data)
}

export async function massMoveDevices(body) {
    return axios
        .patch(`${process.env.API_URL}/devices/mass/move-v3`, body)
        .then(response => response.data)
}

export async function massDeleteDevices(body) {
    return axios
        .delete(`${process.env.API_URL}/devices/mass/delete`, {
            data: body
        })
        .then(response => response.data)
}

export async function massSwitchOffDevices(body) {
    return axios
        .patch(`${process.env.API_URL}/devices/mass/set-offline`, body)
        .then(response => response.data)
}

export async function massSwitchOnMModeDevices(body) {
    return axios
        .patch(`${process.env.API_URL}/devices/mass/maintenance-mode`, body)
        .then(response => response.data)
}
